import { Component, EventEmitter, Input, Output } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { HttpService } from '../../service/http.service';
import { GlobalService } from '../../service/global.service';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-view-chat-history',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './view-chat-history.component.html',
  styleUrl: './view-chat-history.component.scss'
})
export class ViewChatHistoryComponent {
  @Output()
  close = new EventEmitter<boolean>();

  @Input()
  chatMessages:Array<any>=[];

  @Input()
  astrologerDetail:any;

  @Input()
  chatDuration:any;

  userId:any;
  constructor(private _route:ActivatedRoute,private _homeService:HttpService,public gS:GlobalService) { }

  ngOnInit(): void {
    this.userId=this.gS.customerId;
    console.log(this.chatMessages);
    console.log(this.astrologerDetail);
    
    
    
  }


  handleOffcanvasClose() {
    console.log('Offcanvas closed!');
    this.close.emit(true);
    // Add your logic here when the offcanvas is closed
  }
}
